export const validateStreetName = (value: string): boolean => {
  return /^(?!\d+$)[A-Za-zÄÖÜäöüß0-9- ./]+$/.test(value);
};
